<div class="wrapper" (click)="stopEvent($event)">
  <p-splitButton
    [label]="label"
    (onClick)="toggleState()"
    [model]="items"
    [styleClass]="styleClass"
    [disabled]="disabled"
  ></p-splitButton>
</div>
